import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { ShieldCheck } from "lucide-react";
import { api } from "@/lib/api";

export default function Privacy() {
  const { slug } = useParams();
  const [d, setD] = useState(null);
  useEffect(() => { api.get(`/public/privacy/${slug}`).then((r) => setD(r.data)).catch(() => setD(false)); }, [slug]);
  if (d === false) return <div className="min-h-screen grid place-items-center text-muted-foreground">Página não encontrada.</div>;
  if (!d) return null;
  return (
    <div className="min-h-screen bg-background py-16 px-6">
      <div className="max-w-2xl mx-auto card-lux p-8" data-testid="privacy-page">
        <ShieldCheck className="h-8 w-8 text-accent" />
        <h1 className="font-heading text-3xl font-bold mt-4">Aviso de privacidade</h1>
        <p className="text-muted-foreground mt-1">{d.name}</p>
        <p className="mt-6 whitespace-pre-wrap leading-relaxed">{d.privacy_notice}</p>
        <p className="mt-6 text-sm text-muted-foreground">Para exercer seus direitos (acesso, correção, exclusão, portabilidade ou revogação), envie sua solicitação pelo próprio WhatsApp da imobiliária.</p>
      </div>
    </div>
  );
}
